import React from "react";

export type BadgeTone =
  | "neutral"
  | "blue"
  | "amber"
  | "green"
  | "red"
  | "purple";

export interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  tone?: BadgeTone;
  icon?: React.ReactNode;
  children?: React.ReactNode;
}

const tones: Record<BadgeTone, string> = {
  neutral: "bg-gray-700/60 text-gray-200 border-gray-600/60",
  blue: "bg-blue-500/12 text-blue-300 border-blue-500/30",
  amber: "bg-accent-500/12 text-accent-300 border-accent-500/30",
  green: "bg-emerald-500/12 text-emerald-300 border-emerald-500/30",
  red: "bg-red-500/12 text-red-300 border-red-500/30",
  purple: "bg-purple-500/12 text-purple-300 border-purple-500/30",
};

/** Small pill / tag — the Gamer/Chicago tags, status chips, etc. */
const Badge: React.FC<BadgeProps> = ({
  tone = "neutral",
  icon,
  className = "",
  children,
  ...rest
}) => (
  <span
    className={`inline-flex items-center gap-1.5 rounded-full border px-3 py-1 text-xs font-medium ${tones[tone]} ${className}`}
    {...rest}
  >
    {icon && <span className="shrink-0">{icon}</span>}
    {children}
  </span>
);

export default Badge;
